import { ApiLegalFoundation } from '../api-types/legal-foundation.api';
import { LegalFoundation } from '../app-types/legal-foundation.app';

/**
 * Transforms an API Legal Foundation object to an App Legal Foundation object.
 * @param input The API Legal Foundation object to transform.
 * @returns The transformed App Legal Foundation object.
 */
export function transformApiLegalFoundationToAppLegalFoundation(input: ApiLegalFoundation): LegalFoundation {
	return {
		id: input.id,
		description: input.description,
		integrationOfficeId: input.integrationOfficeId,
		sponsorId: input.sponsorId,
		needsDocumentForSos: input.needsDocumentForSos,
	};
}

/**
 * Transforms an array of API Legal Foundation objects to an array of App Legal Foundation objects.
 * @param inputs The array of API Legal Foundation objects to transform.
 * @returns The array of transformed App Legal Foundation objects.
 */
export function transformApiLegalFoundationsToAppLegalFoundations(inputs: ApiLegalFoundation[]): LegalFoundation[] {
	return inputs.map(transformApiLegalFoundationToAppLegalFoundation);
}
